/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'confluence-table-tree.column.contributors': '投稿者',
  'confluence-table-tree.column.last-modified': '最終更新日',
  'confluence-table-tree.column.title': '名前',
  'confluence-table-tree.could-not-load': '読み込めませんでした。',
  'confluence-table-tree.could-not-load-contributors': '投稿者を読み込めませんでした。',
  'confluence-table-tree.create-child-page': '子ページを作成',
  'confluence-table-tree.create-page': 'ページを作成',
  'confluence-table-tree.default.page.title': '無題',
  'confluence-table-tree.default.show-all-pages-button.label': 'さらにページを表示',
  'confluence-table-tree.draft.lozenge': 'ドラフト',
  'confluence-table-tree.draft.tooltip': 'ドラフトは他のユーザーには表示されません。',
  'confluence-table-tree.drafts-toggle.label': '下書きを表示',
  'confluence-table-tree.edit': '編集',
  'confluence-table-tree.edit-in-confluence': 'Confluence で編集',
  'confluence-table-tree.empty.description':
    'ミーティング議事録、製品要件、決定事項やその他のコンテンツを作成して、このスペースを埋めましょう。',
  'confluence-table-tree.empty.title': '現在は何も含まれていません。',
  'confluence-table-tree.error.description': 'ページを表示できません。しばらくしてからもう一度お試しください。',
  'confluence-table-tree.error.row': 'ページを読み込めません。',
  'confluence-table-tree.error.title': '正常に機能していません。',
  'confluence-table-tree.friendly-when-created': '作成日',
  'confluence-table-tree.friendly-when-updated': '最終更新',
  'confluence-table-tree.share.copied': 'クリップボードにコピーされました',
  'confluence-table-tree.share.copy-button': 'コピー',
  'confluence-table-tree.share.subtitle': 'このリンクを共有',
  'confluence-table-tree.share.title': 'ページの共有',
  'confluence-table-tree.share.tooltip': '共有',
  'confluence-table-tree.view-profile': 'プロファイルを表示',
};
